import React from 'react';
import styles from './TopBar3.module.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TopBar3 = ({ branding }) => {
  const { user } = useAuth();

  const phone =
    branding?.phones?.join(" | ") ||
    user?.companyPhone ||
    "+91 0000000000";

  const email =
    branding?.email ||
    user?.companyEmail ||
    "contact@travel.com";

  const facebookUrl =
    branding?.socials?.facebook || "#";

  const instagramUrl =
    branding?.socials?.instagram || "#";

  const twitterUrl =
    branding?.socials?.x || "#";

  return (
    <div className={styles.topBar}>
      <div className={styles.container}>
        
        {/* Contact Group */}
        <div className={styles.infoWrapper}>
          <div className={styles.item}>
            <FaPhoneAlt className={styles.brandIcon} />
            <span className={styles.text}>{phone}</span>
          </div>

          <span className={styles.bullet}>•</span>

          <div className={styles.item}>
            <FaEnvelope className={styles.brandIcon} />
            <span className={styles.text}>{email}</span>
          </div>
        </div>

        {/* Social Media */}
        <div className={styles.socialWrapper}>
          <a href={facebookUrl} target="_blank" rel="noreferrer" className={styles.socialSquare}>
            <FaFacebookF />
          </a>

          <a href={instagramUrl} target="_blank" rel="noreferrer" className={styles.socialSquare}>
            <FaInstagram />
          </a>

          <a href={twitterUrl} target="_blank" rel="noreferrer" className={styles.socialSquare}>
            <FaTwitter />
          </a>
        </div>

      </div>
    </div>
  );
};

export default TopBar3;